import { ofType } from "redux-observable";
import { guard } from "../../../guards/guard";
import { TypeActionBuildings } from "../actionBuildings";
import { checkBuildingInProduction } from "../checks/checkBuildingInProduction";
import { checkBuildingUpgradeHasEnoughLevel } from "../checks/checkBuildingUpgradeHasEnoughLevel";
import { checkBuildingUpgradeHasEnoughResourcePremium } from "../checks/checkBuildingUpgradeHasEnoughResourcePremium";
import { checkBuildingUpgradeHasEnoughResourceStandard } from "../checks/checkBuildingUpgradeHasEnoughResourceStandard";
import { checkBuildingUpgradeHasEnoughWorker } from "../checks/checkBuildingUpgradeHasEnoughWorker";
import { checkBuildingUpgradeIsConstructionInProgress } from "../checks/checkBuildingUpgradeIsConstructionInProgress";
import { pathBuildingUpgradeCharacterHelpMissingLevel } from "../path/pathBuildingUpgradeCharacterHelpMissingLevel";
import { pathBuildingUpgradeCharacterHelpMissingWorker } from "../path/pathBuildingUpgradeCharacterHelpMissingWorker";
import { pathBuildingUpgradeNotEnoughResourcePremium } from "../path/pathBuildingUpgradeNotEnoughResourcePremium";
import { pathBuildingUpgradeNotEnoughResourceStandard } from "../path/pathBuildingUpgradeNotEnoughResourceStandard";
import { pathBuildingUpgradePurchaseInitiate } from "../path/pathBuildingUpgradePurchaseInitiate";
import { pathConstructionInProgress } from "../path/pathConstructionInProgress";
import { pathSkipBuildingProduction } from "../path/pathSkipBuildingProduction";
export var epicBuildingsRequestUpgrade = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.RequestUpgrade), guard(state$, deps, pathBuildingUpgradePurchaseInitiate)([
        checkBuildingUpgradeHasEnoughLevel(pathBuildingUpgradeCharacterHelpMissingLevel),
        checkBuildingUpgradeIsConstructionInProgress(pathConstructionInProgress),
        checkBuildingUpgradeHasEnoughWorker(pathBuildingUpgradeCharacterHelpMissingWorker),
        checkBuildingUpgradeHasEnoughResourceStandard(pathBuildingUpgradeNotEnoughResourceStandard),
        checkBuildingUpgradeHasEnoughResourcePremium(pathBuildingUpgradeNotEnoughResourcePremium),
        checkBuildingInProduction(pathSkipBuildingProduction),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsRequestUpgrade.ts
// module id = 2070
// module chunks = 3